module.exports = __webpack_public_path__ + "img/6clubs.cb0728e2.jpg";